import Axios from "axios";
import config from "../../config/local-config";
import apiConfig from "../../config/api-config";
import dateFormat from "./dateFormat";
import createFormData from "./createFormData";

const version = "v1.1";
const serviceName = "Order";
const site = `${config.hydra.site}`;

const FetchCartAPI = (orderId, tokenDB) => {
  const apiUrl = `${
    apiConfig.apiURL
  }/proxy-order/${serviceName}/${version}/index`;
  return new Promise((resolve, reject) => {
    let body = {
      order_id: orderId,
      iat: dateFormat,
      opt: "get",
      domain: site,
      data: {
        access_token: tokenDB.access_token,
        customer_id: tokenDB.customer_id,
        refresh_token: tokenDB.refresh_token
      }
    };

    // added data into fordata for post request
    const bodyFormData = createFormData(body);
    // returning promise for the request

    Axios.post(apiUrl, bodyFormData, {
      headers: {
        apikey: apiConfig.apiKey
      }
    })
      .then(response => {
        if (response) {
          resolve(response);
        } else {
          resolve(false);
        }
      })
      .catch(err => {
        reject(err);
      });
  });
};
export default FetchCartAPI;
